import { useEffect } from 'react';

type AnalyticsPageViewProps = {
  endpoint?: string;
  companyId?: string;
  assetId?: string;
  memberKey?: string | null;
  clientApiToken?: string;
  recordSessionReplay?: boolean;
  defaultOptOutPiiTracking?: boolean;
  documentRevision?: number;
  preview?: boolean;
};

export function AnalyticsPageView({
  endpoint,
  companyId,
  assetId,
  memberKey,
  clientApiToken,
  recordSessionReplay,
  defaultOptOutPiiTracking,
  documentRevision,
  preview,
}: AnalyticsPageViewProps) {
  useEffect(() => {
    if (preview || !endpoint || !companyId || !assetId || !clientApiToken) {
      return;
    }

    void import('@mutiny-pkg/analytics-tracker/src/index')
      .then(({ collectPageViewMetadata, init }) => {
        const metadata = collectPageViewMetadata({ documentRevision });
        init({
          endpoint,
          companyId,
          assetId,
          memberKey,
          clientApiToken,
          recordSessionReplay,
          defaultOptOutPiiTracking,
          ...(Object.keys(metadata).length > 0 ? { metadata } : {}),
        });
      })
      .catch(() => {
        // Tracking must never break published page rendering.
      });
  }, [
    assetId,
    clientApiToken,
    companyId,
    defaultOptOutPiiTracking,
    documentRevision,
    endpoint,
    memberKey,
    preview,
    recordSessionReplay,
  ]);

  return null;
}
